import * as React from 'react';
import {
  Edit,
  SimpleForm,
} from 'react-admin';
import ConsumablesCalculatorMultiControlForm from './ConsumablesCalculatorMultiControlForm';
import FormToolbar from '../shared/FormToolbar';

const ConsumablesCalculatorMultiControlEdit = props => (
  <Edit {...props} undoable={false}>
    <SimpleForm toolbar={<FormToolbar />}>
      <ConsumablesCalculatorMultiControlForm {...props} />
    </SimpleForm>
  </Edit>
);

export default ConsumablesCalculatorMultiControlEdit;
